import { BrowserRouter } from 'react-router';
import { ResponsiveShell } from './layouts/ResponsiveShell';
import { AppRoutes } from './router';
import { ErrorBoundary } from './components/ErrorBoundary';

export function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <ResponsiveShell>
          <AppRoutes />
        </ResponsiveShell>
      </BrowserRouter>
    </ErrorBoundary>
  );
}
